export const HOME_ROUTE = '';
export const MAP_ROUTE = 'map';
export const MAP_FAKE_ROUTE = 'map-fake';
export const TABLE_ROUTE = 'table';
export const TABLE_FAKE_ROUTE = 'table-fake';
export const SERVICE2_ROUTE = 'GF-service-1';
export const SERVICE1_ROUTE = 'GF-service-2';
